import React, { useState, useEffect, useCallback } from 'react';
import { Upload, Spin, Progress, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import PQueue from 'p-queue';
import { swrInvalidateMany } from '~/libs/helpers';

import { uploadFile, addExpense, addInvoice } from '~/libs/requests';
const GetUploadPool = new PQueue({ concurrency: 3 });

const UploadDropContainer = styled.div`
	margin-bottom: 15px;
`;

const beforeUpload = (file) => {
	const isJPG = file.type === 'image/jpeg';
	const isPNG = file.type === 'image/png';
	const isPDF = file.type === 'application/pdf';
	if (!isJPG && !isPNG && !isPDF) {
		alert('You can only upload a JPG, PNGs or PDF file (this file is ' + file.type + ').');
		return false;
	}
	const isLt2M = file.size / 1024 / 1024 < 5;
	if (!isLt2M) {
		alert('The document must smaller than 5MB.');
		return false;
	}
	return true;
}

const UploadDrop = (props) => {
	const [total, setTotal] = useState(0);
	const [uploaded, setUploaded] = useState(0);
	const [uploading, setUploading] = useState(false);
	const { mode = 'uploads', text = 'Drop your files here' } = props;

	const processRemainingFiles = async (file, onSuccess) => {
		await GetUploadPool.add(async () => {
			const res = await uploadFile(file);
			if (res.success) {
				if (mode === 'expenses') {
					console.log('expenses', res, res.data._id);
					await addExpense(res.data._id);
					message.info("Added a new expense.");
					swrInvalidateMany('/api/expenses');
				}
				if (mode === 'invoices') {
					await addInvoice(res.data._id);
					message.info("Added a new invoice.");
					swrInvalidateMany('/api/invoices');
				}
			}
			else {
				message.error(res.message);
			}
		});
		setUploaded(uploaded => uploaded + 1);
		onSuccess(null, file);
		swrInvalidateMany('/api/uploads');
	}
	
	useEffect(() => {
		if (uploaded > 0 && uploaded === total) {
			setTimeout(() => {
				setUploading(false);
				setUploaded(0);
				setTotal(0);
			}, 800);
		}
	}, [uploaded]);

	const onDropFile = useCallback((info) => {
		const { file, onSuccess } = info;
		setTotal(total => total + 1);
		if (!uploading) {
			setUploading(true);
		}
		processRemainingFiles(file, onSuccess);
	});

	let percent = Math.round((uploaded / total) * 100);

	return (
		<UploadDropContainer style={{ margin: 0 }}>
			<Spin spinning={uploading}>
				<Upload.Dragger name='file' multiple={true} style={{ background: 'rgb(235 246 255)' }}
					customRequest={onDropFile} showUploadList={false} beforeUpload={beforeUpload}>
					<p className="ant-upload-drag-icon"><UploadOutlined /></p>
					<p className="ant-upload-text" style={{ color: '#3fa9ff', textTransform: 'uppercase', fontSize: 12, margin: 0 }}>
						{text}
					</p>
					<p className="ant-upload-hint" style={{ color: '#8eccff', fontSize: 12 }}>
						JPG, PNG and PDF
					</p>
				</Upload.Dragger>
			</Spin>
			{uploading && <Progress status={uploading ? 'active' : 'normal'} percent={percent} />}
		</UploadDropContainer>
	);
}

export default UploadDrop;